import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FBASE_CONF_API_KEY,
  authDomain: process.env.REACT_APP_FBASE_CONF_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FBASE_CONF_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FBASE_CONF_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FBASE_CONF_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FBASE_CONF_APP_ID,
  measurementId: process.env.REACT_APP_FBASE_CONF_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
export { storage };
export { db };
export const auth = getAuth(app);
